export class Lesson {
    id: string;
    title: string;
    background: string;
    description: string;
    sections: string[];
}